<script>
import {defineComponent} from "vue";
import ProductHelperMixin from "@/mixins/productHelperMixin";
import Graphic from "@/components/graphics/Graphic.vue";
import blockElementMixin from "@/mixins/blockElementMixin";

export default defineComponent({
	name: "AnimatedRegion",
	components: {Graphic},
	mixins: [ProductHelperMixin, blockElementMixin],
	props: {
		product: {
			type: Object,
			default: () => {
				return {};
			}
		},
		region: {
			type: Object,
			default: () => {
				return {};
			}
		}
	},

	computed: {
		sources() {
			return [this.extractProductProp('contentSource')];
		},
		autoplay() {
			return this.extractProductProp('inblockAutoplay') || true;
		},
		delay() {
			return Number(this.extractProductProp('inblockDelay') || 0);
		},
		loop() {
			return this.extractProductProp('inblockLoop') || false;
		},
		loopCount() {
			return parseInt(this.extractProductProp('loopCount') || 0, 10);
		}
	},
	watch:{
		/*isInViewport(val){
			if(val){
				this.$refs.graphic?.start();
				console.log('Starting Animation!');
			} else {
				this.$refs.graphic?.pause();
				console.log('Pausing Animation!');
			}
		}*/
	}
});
</script>

<template>
	<graphic :autoplay="autoplay" :delay="delay" :loop="loop" :loop-count="loopCount" :muted="true" :src="sources" :is-visible="isInViewport" reg="graphic"/>
</template>

<style lang="scss" scoped>
video, canvas, img {
  width: 100%;
  height: 100%;
}
</style>
